// =============================================================================
// CONTACT MOON DATA
// =============================================================================
// Data for the contact ring moons (email, coaching, linkedin)
// Single source of truth for contact info and testimonials

export interface Testimonial {
  quote: string;
  author: string;
  role: string;
}

export interface ContactMoon {
  id: string;
  category: string;
  headline: string;
  subhead: string | null;
  color: string;
  action: "copy" | "link";
  url?: string;
  testimonials?: Testimonial[];
}

// Contact moons in ring order: email, coaching, linkedin
export const CONTACT_MOONS: ContactMoon[] = [
  {
    id: "email",
    category: "Email",
    headline: "hello@vincentngu.com",
    subhead: null,
    color: "#0D9488", // Teal
    action: "copy",
  },
  {
    id: "tec",
    category: "Coaching",
    headline: "Design Career Strategy",
    subhead: null,
    color: "#D4AF37", // Gold
    action: "link",
    url: "https://forms.gle/14tj22CypKWHhmh29",
    testimonials: [
      {
        quote: "Vincent\u2019s been someone I\u2019ve turned to for guidance over the past five years. He helped me move past confidence struggles to develop a strong point of view and think more strategically about impact. His mentorship goes far beyond design craft \u2014 he genuinely cares about my growth.",
        author: "Kerry L.",
        role: "Product Designer",
      },
    ],
  },
  {
    id: "linkedin",
    category: "LinkedIn",
    headline: "/in/vincentnoob",
    subhead: null,
    color: "#0077B5", // LinkedIn blue
    action: "link",
    url: "https://linkedin.com/in/vincentnoob",
    testimonials: [
      {
        quote: "Vincent is already operating at the next level. I can confidently hand him a project without any concerns. He has been my co-lead\u2014and at times, my guide\u2014on the Video Player Redesign project, and having someone with his level of ownership and expertise is incredibly valuable.",
        author: "Ayca A.",
        role: "Principal Product Manager",
      },
    ],
  },
];
